import React from "react";
import useDebouncedCallback from "./useDebouncedCallback";

const withDebouncedCallback =
  (name, delay = 1000) =>
  (BaseComponent) => {
    const EnhancedComponent = (props) => {
      const debouncedCallback = useDebouncedCallback(props[name], delay);
      return React.createElement(BaseComponent, {
        ...props,
        [name]: debouncedCallback,
      });
    };
    return EnhancedComponent;
  };

export default withDebouncedCallback;
